module.exports = __webpack_public_path__ + "img/1M.501d2ba2.jpg";